import React from "react";
import { Container, Row, Col, Card, ListGroup, Button, Image, Table } from "react-bootstrap";
import { FaFacebook, FaTiktok, FaYoutube, FaInstagram, FaComment, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useState } from "react";
import Footer from './footer';
import { motion } from "framer-motion";
import LatestUpdates from "./latestupdates";
import "./img.css";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const VisaTable = () => {
  return (
    <div className="mt-4 table-responsive">
      <Table bordered hover className="table" >
        <thead className="table">
          <tr>
            <th>TYPE</th>
            <th>DESCRIPTION</th>
            <th>STAY</th>
            <th>COST</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <strong>Post-Vocational Education Work stream</strong>
            </td>
            <td>
            This visa is for international students who have recently graduated with an associate degree, 
            diploma or trade qualification relevant to an occupation Australia needs. It allows you to live, 
            study and work in Australia temporarily.

            </td>
            <td>Up to 18 months.
                Hong Kong and British National Overseas passport holders may stay for 5 years.​</td>
            <td>From AUD 2,300.00</td>
          </tr>

          <tr>
            <td>
              <strong>Post-Higher Education Work stream</strong>
            </td>
            <td>
            This visa is for international students who have recently graduated with a degree from an Australian institution. 
            It allows you to live, work and study in Australia temporarily.

            </td>
            <td>Usually between 2 and 3 years, depending on your qualification.
             Hong Kong and British National Overseas passport holders may stay for 5 years.</td>
            <td>From AUD 2,300.00</td>
          </tr>

          <tr>
            <td>
              <strong>Second Post-Higher Education Work stream</strong>
            </td>
            <td>
            This visa is for Temporary Graduates holding a Post-Higher Education Work, 
            Post-Study Work or Replacement visa with a degree from an Australian institution located in a regional area. 
            It allows you to live, work and study in Australia temporarily.

            </td>
            <td>Between 1 and 2 years depending on:

the regional location of the educational institution that you graduated from that led to the grant of your first Temporary Graduate visa
the regional area that you live in as the holder of your Temporary Graduate visa in the Post-Higher Education Work, Post-Study Work or Replacement stream</td>
            <td>From AUD 905.00


</td>
          </tr>

        </tbody>
      </Table>
    </div>
  );
};










const ContentSection = () => (
  <Container className="mt-4">
    <Row>
      <Col md={8}>
        <p className="mt-3">
          The 485 Visa is a temporary visa that allows international students who have recently completed 2 years of study from an Australian educational institution,
          to live and work in the country for between 18 months and 4 years.
        </p>
        <p className="mt-3">
          This is a temporary visa. The primary applicant must be in Australia when they make their application for a 485 visa,
          and must have held an eligible student visa within the 6-month period prior to lodgement.
        </p>
        <p className="mt-3">
          Bajwa Immigration currently has a great offer for 485 applicants - if you enroll in a full-time course through us, we will lodge your 485 application for no charges.
          Your application will be prepared with accuracy by our expert team.
        </p>
        <h4>BASIC ELIGIBILITY</h4>
        <p>You must:</p>
        <ul>
          <li>be aged 35 years or under when you apply. *Exceptions apply</li>
          <li>Hold an eligible visa</li>
          <li>Have a recent qualification in a CRICOS-registered course</li>
          <li>apply for your eligible stream (it is not possible to change streams after you apply)</li>
          <li>attach required evidence when you apply</li>
        </ul>
        <h4>COMMON REQUIREMENTS</h4>
        <ul>
          <li><strong>Age:</strong> The main applicant must be under 35 at the date of lodgment.</li>
          <li>
            <strong>English:</strong> The main applicant must demonstrate their English language ability,
            either through holding certain types of passports or by undertaking an English test.
            Evidence of threshold English must be provided at the date of lodgment.
          </li>
          <li>
            <strong>Study in Australia:</strong> You must meet the 2-year study requirement and have
            completed qualifications within six months of applying for the visa.
          </li>
          <li><strong>Point Test:</strong> The Temporary Graduate subclass 485 visa is not points-tested.</li>
        </ul>
        <h4>ENGLISH REQUIREMENTS</h4>
        <p>
          The new English requirements for both the Post Study Work Stream and Graduate Work Stream
          are as follows:
        </p>
        <ul>
          <li>
            Hold a passport from the UK, Ireland, USA, Canada, or New Zealand; or
          </li>
          <li>
            <strong>IELTS</strong> (Academic or General Training): overall average of 6 and at least
            5 in each band; or
          </li>
          <li>
            <strong>Occupational English Test</strong> (OET): B Pass in each band; or
          </li>
          <li>
            <strong>Pearson</strong> (PTE Academic): overall average of 50 with at least 36 in each
            band; or
          </li>
          <li>
            <strong>TOEFL iBT</strong> (Internet Based Test): total score of 64, with at least 4 in
            Listening and Reading, and at least 14 in Writing and Speaking; or
          </li>
          <li>
            <strong>Cambridge (CAE):</strong> 169 overall average with at least 154 in each band.
          </li>
        </ul>
        <p>
          This represents a significant lowering of the English language requirement and will be a
          great relief to applicants who have struggled to meet the minimum score required in each
          band.
        </p>

        <h4>WHAT YOU CAN DO</h4>
        <p>This visa allows you to:</p>
        <ul>
          <li>Stay in Australia for the period that aligns with the approved activities on this visa.</li>
          <li>Graduate Work Stream – up to 18 months</li>
          <li>Post Study Work Stream – up to four years</li>
          <li>Do work or activity specified in your application</li>
          <li>Bring eligible family members with you to Australia</li>
          <li>Enter and leave Australia as many times as you want while your visa is valid.</li>
        </ul>
        <br/>
        <VisaTable />
        <br/>
      
      </Col>

      {/* Sidebar Section */}
      <Col md={4}>
        <Card className="p-3 text-center">
          {/* Bajwa Immigration Image */}
          <Image
            src="./img/brand-logo.png"
            alt="Bajwa Immigration Logo"
            fluid
            className="mb-3"
          />

          <h6 className="fw-bold">Subscribe to our YouTube channel</h6>
          <Button variant="danger" className="mb-3"><a href="https://www.youtube.com/embed/uOGAB9oYets">SUBSCRIBE</a></Button>

          <h6 className="fw-bold">Book Consultation</h6>
          <Button variant="warning">BOOK CONSULTATION</Button>

          <h6 className="fw-bold mt-3">Like Us on Facebook !!</h6>
          {/* Facebook Embed */}
          <iframe
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FBajwaImmigration&tabs&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
            width="100%"
            height="130"
            style={{ border: "none", overflow: "hidden" }}
            scrolling="no"
            frameBorder="0"
            allowFullScreen
          ></iframe>

          {/* Social Media */}
          <h6 className="fw-bold mt-3">We are also on:</h6>
          <div className="d-flex justify-content-center gap-3">
            <FaInstagram size={30} color="#C13584" />
            <FaTiktok size={30} color="#000" />
            <FaYoutube size={30} color="crimson" />
          </div>
        </Card>
      </Col>
    </Row>
  </Container>
);


const TemporaryGraduateVisa = () => {
  return (
    <>
      <Container className="mt-4">
        <h1 className="fw-bold">Temporary Graduate Visa (Subclass 485)</h1>

        {/* YouTube Embed Section */}
        <Row className="mt-3">
          <Col md={8}>
            <div className="ratio ratio-16x9">
              <iframe
                width="100%"
                height="400"
                src="https://www.youtube.com/embed/aLi5-7Z3Sks"
                title="YouTube video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </Col>

          {/* Sidebar - Latest Posts */}
          <Col md={4}>
                        <Card>
                            <Card.Header className="fw-bold">Latest Posts</Card.Header>
                            <ListGroup variant="flush">
                                <ListGroup.Item><Link to="/professional" className="dropdown-item"> <a href="" className="text-decoration-none">Professional Year</a> </Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/coursechange" className="dropdown-item"> <a href="" className="text-decoration-none">Admissions And Course Change </a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/skilledID" className="dropdown-item"> <a href="" className="text-decoration-none">   Skilled Independent Visa (Subclass 189)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/workregionalvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/nominatedvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</a></Link></ListGroup.Item>
                               <ListGroup.Item><a href="https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/skilled-regional-191"className="dropdown-item text-decoration-none"style={{ color: "#22327f" }}target="_blank"rel="noopener noreferrer">Permanent Residence visa (Subclass 191)</a></ListGroup.Item>
                                {/* <ListGroup.Item><Link to="/regionalvisa" className="dropdown-item"><a href="" className="text-decoration-none">Skilled Regional Visa (Subclass 887)</a></Link></ListGroup.Item> */
                                <ListGroup.Item><Link to="/tempactivity" className="dropdown-item"><a href="" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</a></Link></ListGroup.Item>
}
                            </ListGroup>
                        </Card>
                    </Col>
        </Row>
      </Container>

      {/* Content Section */}
      <ContentSection />


      {/* Floating Feedback Button */}
      <div className="position-fixed bottom-0 stAAT-0 m-3">
      <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 stAAT-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>
      </div>
      <LatestUpdates/>
      <Footer />
    </>
  );
};

export default TemporaryGraduateVisa;